import { render, staticRenderFns } from "./AuthResult.vue?vue&type=template&id=4e61f734&scoped=true&"
import script from "./AuthResult.vue?vue&type=script&lang=js&"
export * from "./AuthResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e61f734",
  null
  
)

export default component.exports